import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ProjectLocationPlanModel } from '../store/models/project-location-plan.model';
import { api } from '../consts/url';
import { HttpClient } from '@angular/common/http';
import { UploadService } from './upload.service';

@Injectable({ providedIn: 'root' })
export class ProjectLocationPlanService {
  private readonly http = inject(HttpClient);
  private readonly uploadService = inject(UploadService);

  public getAll(projectId: string): Observable<ProjectLocationPlanModel.PlanDocument[]> {
    return this.http.get<ProjectLocationPlanModel.PlanDocument[]>(api.project.plan.crud(projectId));
  }

  public create(
    projectId: string,
    locationId: string,
    payload: ProjectLocationPlanModel.API.CreatePlanDto,
  ): Observable<ProjectLocationPlanModel.PlanDocument> {
    return this.http.post<ProjectLocationPlanModel.PlanDocument>(
      api.project.plan.create(projectId, locationId),
      payload,
    );
  }

  public getSelectedPlan(planId: string): Observable<ProjectLocationPlanModel.PlanDocument> {
    return this.http.get<ProjectLocationPlanModel.PlanDocument>(api.project.plan.crudById(planId));
  }

  public copyPlan(planId: string): Observable<ProjectLocationPlanModel.PlanDocument> {
    return this.http.post<ProjectLocationPlanModel.PlanDocument>(api.project.plan.copyPlan(planId), {});
  }

  public savePlan(planId: string, data: ProjectLocationPlanModel.API.UpdatePlan): Observable<ProjectLocationPlanModel.PlanDocument> {
    return this.http.put<ProjectLocationPlanModel.PlanDocument>(api.project.plan.crudById(planId), { ...data });
  }

  public deletePlan(planId: string): Observable<boolean> {
    return this.http.delete<boolean>(api.project.plan.crudById(planId));
  }

  public uploadImage(
    planId: string,
    filename: string
  ): Observable<ProjectLocationPlanModel.API.GenerateFloorImageUploadUrlResponse> {
    return this.http.post<ProjectLocationPlanModel.API.GenerateFloorImageUploadUrlResponse>(api.project.plan.uploadFloorImage(planId), { filename: filename });
  }

  public uploadAttachmentToSignedUrl(request: {
    url: string;
    file: File;
    filename: string;
    headers?: Record<string, string>;
  }): Observable<unknown> {
    return this.uploadService.uploadPresignedUrl(request);
  }

  public storageDownload(floorImageUrl: string): Observable<Blob> {
    return this.http.get(api.downloadPlanImage(floorImageUrl), {
      responseType: 'blob',
    });
  }
}
